import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export default function NavigationItem({
  text,
  rootUrl,
  active = false,
  children,
  badge,
  onNavigationItemClick,
  target,
}) {
  return (
    <li className="site-navigation__item">
      <a
        className={classNames({
          ta__confirmation: true,
          'site-navigation__item-link': true,
          'site-navigation__item-link--active': active,
        })}
        href={rootUrl}
        target={target}
        onClick={onNavigationItemClick}
      >
        {children}
        {text}
        {badge}
      </a>
    </li>
  );
}

NavigationItem.defaultProps = {
  target: '_self',
};

NavigationItem.propTypes = {
  text: PropTypes.string.isRequired,
  rootUrl: PropTypes.string.isRequired,
  active: PropTypes.bool,
  children: PropTypes.node,
  badge: PropTypes.node,
  onNavigationItemClick: PropTypes.func,
  target: PropTypes.oneOf(['_blank', '_self', '_parent', '_top']),
};



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/components/Navigation/NavigationItem.js
 **/